import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const BOOT_DURATION = 480; // ms — fast & slick per spec

export default function BootSequence() {
    const [visible, setVisible] = useState(true);
    const [phase, setPhase] = useState(0); // 0: grid, 1: wordmark, 2: fade-out

    useEffect(() => {
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduced) {
            setVisible(false);
            return;
        }
        const t1 = setTimeout(() => setPhase(1), 140);
        const t2 = setTimeout(() => setPhase(2), 320);
        const t3 = setTimeout(() => setVisible(false), BOOT_DURATION);
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            clearTimeout(t3);
        };
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    data-testid="boot-sequence"
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.18, ease: "easeOut" }}
                    className="fixed inset-0 z-[100] pointer-events-none flex items-center justify-center bg-tca-deep"
                >
                    {/* Grid lines drawing in */}
                    <motion.div
                        className="absolute inset-0 tca-grid-bg-fine"
                        initial={{ opacity: 0, scale: 0.97 }}
                        animate={{ opacity: phase >= 0 ? 1 : 0, scale: 1 }}
                        transition={{ duration: 0.24, ease: "easeOut" }}
                    />
                    {/* Cyan scan-line sweep */}
                    <motion.div
                        className="absolute left-0 right-0 h-[2px]"
                        style={{
                            background:
                                "linear-gradient(90deg, transparent 0%, rgba(0,224,232,0) 5%, rgba(0,224,232,0.8) 50%, rgba(0,224,232,0) 95%, transparent 100%)",
                            boxShadow: "0 0 22px rgba(0,224,232,0.7)",
                        }}
                        initial={{ top: "-2%" }}
                        animate={{ top: "102%" }}
                        transition={{ duration: 0.42, ease: "easeInOut" }}
                    />
                    {/* Wordmark type-in */}
                    <motion.div
                        className="font-mono-tight text-tca-cyan text-xs sm:text-sm tracking-[0.4em]"
                        initial={{ opacity: 0, y: 4 }}
                        animate={{ opacity: phase >= 1 ? 1 : 0, y: 0 }}
                        transition={{ duration: 0.18 }}
                    >
                        <span className="opacity-70">[</span>
                        <span className="mx-2">QUADRA CORE® · BOOT OK</span>
                        <span className="opacity-70">]</span>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
